<template>
  <header class="navbar">
    <div class="navbar-inner">
      <a href="/" class="logo">
        <img
          src="https://djqsmiqswxrv8.cloudfront.net/joy2ever/web/joy2ever-logo.png"
          alt="Logo"
        />
      </a>
      <nav class="menus">
        <el-menu
          :default-active="activeIndex"
          class="nav-menu"
          mode="horizontal"
          :router="true"
          text-color="#e5ca8a"
          background-color="transparent"
          active-text-color="#cba24c"
        >
          <el-menu-item index="/">
            <span class="nav-span">Home</span>
          </el-menu-item>
          <el-menu-item index="/privacy-policy">
            <span class="nav-span">Privacy Policy</span>
          </el-menu-item>
          <el-menu-item index="/terms-of-service">
            <span class="nav-span">Terms of Service</span>
          </el-menu-item>
        </el-menu>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  computed: {
    activeIndex() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="less" scoped>
@import "element-ui/lib/theme-chalk/display.css";
@import url("../assets/style/colors.less");

.navbar {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1000;
  background-color: @lanmu;
  box-sizing: border-box;
  min-height: 48px;
  padding: 0.5rem 4rem 0.5rem 2rem;
  display: flex;
  align-items: center;
}

.navbar-inner {
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.logo img {
  height: clamp(28px, 2.5vw, 40px);
  display: block;
}

.menus {
  min-width: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  .nav-menu {
    border: none;
    background: transparent !important;
    white-space: nowrap;

    /deep/ .el-menu-item {
      padding: 0 14px;
      font-size: clamp(12px, 1vw, 15px);
      height: 40px;
      line-height: 40px;
      font-weight: 600;
      background: transparent !important;
      background-color: transparent !important;
      border-bottom: none !important;
      box-shadow: none !important;
      text-shadow: none !important;
      transition: color 0.2s ease;

      &:hover,
      &:focus {
        background: transparent !important;
        background-color: transparent !important;
        border-bottom: none !important;
        box-shadow: none !important;
        text-shadow: none !important;
        color: #cba24c !important;
      }

      &.is-active {
        background: transparent !important;
        background-color: transparent !important;
        border-bottom: none !important;
        box-shadow: none !important;
        text-shadow: none !important;
        color: #cba24c !important;

        .nav-span {
          border-bottom: 2px solid #cba24c;
          padding-bottom: 2px;
          box-shadow: none;
          text-shadow: none;
        }
      }
    }
  }
}

.nav-span {
  font-size: inherit;
  letter-spacing: 0.02em;
  border-bottom: 2px solid transparent;
  padding-bottom: 2px;
  box-shadow: none;
  text-shadow: none;
  transition: border-color 0.2s ease, color 0.2s ease;
}

@media screen and (max-width: 750px) {
  .navbar {
    padding: 0.5rem 1rem;
  }

  .menus .nav-menu .el-menu-item {
    padding: 0 8px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue